import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Gamepad2, Lock, Mail, LogIn, Info } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) toast.error(res.error);
    else toast.success("Bem-vindo!");
  };

  return (
    <div className="min-h-screen arcade-grid flex items-center justify-center p-5">
      <div className="phone-frame phone-frame-full w-full">
        <div className="neon-card-violet p-7 slide-up">
          <div className="flex flex-col items-start gap-3 mb-7">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-violet-500 via-fuchsia-500 to-amber-400 flex items-center justify-center shadow-xl shadow-violet-500/40">
              <Gamepad2 size={28} className="text-white" strokeWidth={2.4} />
            </div>
            <div>
              <h1 className="font-arcade text-3xl font-extrabold text-white tracking-tight">
                VendaPlay
              </h1>
              <p className="text-sm text-slate-300 mt-1">
                Gamificação de vendas no seu bolso 🎮
              </p>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-3" data-testid="login-form">
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
              <input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@exemplo.com"
                className="arcade-input pl-11"
                required
                autoComplete="email"
              />
            </div>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
              <input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Senha"
                className="arcade-input pl-11"
                required
                minLength={6}
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="btn-arcade w-full flex items-center justify-center gap-2 text-base disabled:opacity-60"
            >
              <LogIn size={18} />
              {loading ? "..." : "Entrar no jogo"}
            </button>
          </form>

          <div className="mt-6 pt-5 border-t border-slate-800 flex items-start gap-2.5 text-xs text-slate-400">
            <Info size={14} className="text-fuchsia-400 shrink-0 mt-0.5" />
            <p>
              Não tem acesso ainda? Fale com o administrador — ele cria seu login no
              painel. Cadastro público está desativado por segurança.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
